/* eslint-disable @next/next/no-img-element */
import { FC } from "react";

const DpdLogo: FC = () => (
  <img src="/assets/images/DPD_logo.svg" title="DPD" alt="DPD" width="70px" height="30px" decoding="async" loading="eager" />
);

export default DpdLogo;
